"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.initialValues = exports.icon = exports.getMetricsPrefix = exports.getMetrics = exports.getDataDefinitions = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var fields = exports.fields = ['file', 'mobileText', 'mobileThumbnail', 'downloadButtonLabel'];
var initialValues = exports.initialValues = {
  file: null,
  mobileText: '<p><a href="[url]" target="_blank" rel="noopener noreferrer">Tap to open: [name]</a></p>',
  mobileThumbnail: null,
  downloadButtonLabel: 'Download'
};
var icon = exports.icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-book"
});
var validate = exports.validate = function validate(values) {
  return {};
};
var getMetricsPrefix = exports.getMetricsPrefix = function getMetricsPrefix() {
  return 'pd';
};
var getDataDefinitions = exports.getDataDefinitions = function getDataDefinitions(id, settings) {
  return {};
};
var getMetrics = exports.getMetrics = function getMetrics(id, settings, answer) {
  return {};
};